// login
export const commonAction = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAIL',
};
export const authType = {
  SUCCESS: 'AUTH_LOGIN',
  FAILURE: 'AUTH_FAILURE',
  LOGOUT: 'AUTH_LOGOUT',
};

export const walletConnection = {
  SUCCESS: 'WALLET_CONNECT_SUCCESS',
  FAILURE: 'WALLET_CONNECT_FAILURE',
  DISCONNECT: 'WALLET_DISCONNECT',
};

export const commonConfig = {
  SUCCESS: 'IPFS_CONFIG_SUCCESS',
  FAILURE: 'IPFS_CONFIG_FAILURE',
};

export const LANGUAGE_CHANGE_SUCCESS = 'LANGUAGE_CHANGE_SUCCESS';
export const LANGUAGE_CHANGE_FAILURE = 'LANGUAGE_CHANGE_FAILURE';

export const bankTransfer = {
  SET_BANK_TRANSFER: 'SET_BANK_TRANSFER',
  CLEAR_BANK_TRANSFER: 'CLEAR_BANK_TRANSFER',
  UPDATE_PENDING_TRANSACTIONS: 'UPDATE_PENDING_TRANSACTIONS',
  CLEAR_SELECTED_TRANSACTION: 'CLEAR_SELECTED_TRANSACTION',
};
